import { authenticatedApi } from './api';

const createInvoice = async (invoiceData: any) => {
  return authenticatedApi.post('invoice/create', invoiceData);
};

const getAllInvoices = async () => {
  return authenticatedApi.get('invoice/all');
};

const getInvoiceById = async (invoiceId: string) => {
  return authenticatedApi.get(`invoice/${invoiceId}`);
};

const downloadExcelFile = async (invoiceId: string) => {
  return authenticatedApi.get(`invoice/excel/${invoiceId}`, { responseType: 'blob' });
};

const downloadNewInvoiceExcelFile = async (data: any) => {
  return authenticatedApi.post(`invoice/newinvoiceexcel`, data, { responseType: 'blob' });
};

const sendInvoiceEmail = async (invoiceId: string) => {
  return authenticatedApi.post(`invoice/email/${invoiceId}`);
};

const addPaymentDate = async (invoiceId: string, paymentDate: string) => {
  return authenticatedApi.put(`invoice/payment/${invoiceId}`, { dateOfPayment: paymentDate });
};

const downloadXmlFile = async (invoiceId: string) => {
  return authenticatedApi.get(`invoice/xml/${invoiceId}`, { responseType: 'blob' });
};

const downloadInvoicePdfFile = async (invoiceId: string) => {
  return authenticatedApi.get(`invoice/pdf/${invoiceId}`, { responseType: 'blob' });
};

const downloadInvoiceWithoutVatPdfFile = async (invoiceId: string) => {
  return authenticatedApi.get(`invoice/pdfwithoutvat/${invoiceId}`, { responseType: 'blob' });
};

const getInvoicesPaginated = async (page: number, limit: number, filter: any) => {
  return authenticatedApi.post(`invoice`, { page, limit, filter });
};

const invoiceApi = {
  createInvoice,
  getAllInvoices,
  downloadExcelFile,
  getInvoiceById,
  sendInvoiceEmail,
  addPaymentDate,
  downloadXmlFile,
  downloadNewInvoiceExcelFile,
  downloadInvoicePdfFile,
  downloadInvoiceWithoutVatPdfFile,
  getInvoicesPaginated,
};

export default invoiceApi;
